export default __webpack_public_path__ + "4f009e445104a12be60826507dc450c0.jpeg";